import { defineVizView } from "@/lib/ai/visualization/views/shared/view-definition";
import {
  buildTimeSeriesAreaElement,
  compileTimeSeriesAreaSpec,
  validateTimeSeriesAreaSpec,
} from "@/lib/ai/visualization/views/time-series-area/logic";
import { timeSeriesAreaAuthoringSchema } from "@/lib/ai/visualization/views/time-series-area/schema";

/**
 * `time-series-area` definition の SSOT エントリ。
 */
export const timeSeriesAreaDefinition = defineVizView({
  type: "time-series-area",
  componentType: "TimeSeriesArea",
  authoringSchema: timeSeriesAreaAuthoringSchema,
  authoringPrompt: {
    summary:
      "Wide time-series area chart for magnitude or share-over-time reading with a small number of additive metrics.",
    requiredKeys: ["xKey", "xLabel", "seriesKeys", "seriesLabelEntries"],
    optionalKeys: [],
    selectionRules: [
      "seriesKeys must contain at least one metric key.",
      "Always provide xLabel in task.outputLanguage.",
      "Always provide seriesLabelEntries using selected metric keys only, and cover every selected metric key.",
      "When dataset queryContext requests moving averages and matching fields share the same metricFamily, include the requested 7d/28d moving-average series with the corresponding raw area series.",
    ],
    avoidWhen: [
      "Mixed-unit multi-metric charts that need strong axis separation.",
      "Precise point-to-point comparison between close values or many crossing lines.",
      "Audit/detail inspection or category ranking tasks.",
      "Very dense grouped series where filled areas would overlap too heavily.",
    ],
    minimalExamples: [
      {
        label: "share-or-magnitude-trend",
        view: {
          type: "time-series-area",
          xKey: "date",
          xLabel: "Date",
          seriesKeys: ["impressions"],
          seriesLabelEntries: [{ key: "impressions", label: "Impressions" }],
        },
      },
    ],
  },
  datasetRequirements: {
    requiresTimeDimension: true,
    requiresCategoryDimension: false,
    minMetricCount: 1,
    requiresCompareMode: false,
  },
  validateSpec: validateTimeSeriesAreaSpec,
  buildElement: buildTimeSeriesAreaElement,
  compileSpec: compileTimeSeriesAreaSpec,
});
